import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src477529347/src/autopatcher-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setting-up-permissions"
    }}>{`Setting up permissions`}</h1>
    <p>{`You can find the AutoPatcher User Interface `}<a parentName="p" {...{
        "href": "http://autopatcher.nordcloudapp.com"
      }}>{`here`}</a>{`. If you do not have enough permissions, contact `}<a parentName="p" {...{
        "href": "mailto:autopatcher@nordcloud.com"
      }}>{`autopatcher@nordcloud.com`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      